import { Box, makeStyles, TableContainer, Typography } from "@material-ui/core";
import React from "react";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Table from "@material-ui/core/Table";

const useStyles = makeStyles((theme) => ({
  box: {
    width: "100%",
    height: "auto",

    [theme.breakpoints.down("md")]: {
      padding: "0 20px",
    },
  },
  table: {
    borderTopWidth: 1,
    borderColor: "rgb(151, 151, 151)",
    borderStyle: "solid",
  },
  border: {
    width: "auto",
  },
  second: {
    width: "33%",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
}));

export default function LastTable() {
  const classes = useStyles();
  return (
    <Box className={classes.box}>
      <Typography color="primary" variant="h2" gutterBottom>
        大国ファーム概要
      </Typography>

      <TableContainer component={Paper} className={classes.gutter}>
        <Table className={classes.table} size="small" aria-label="simple table">
          <TableBody>
            <TableRow>
              <TableCell className={classes.second}>住所</TableCell>
              <TableCell className={classes.border}>富田林市佐備</TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.second}>面積</TableCell>
              <TableCell className={classes.border}>1400坪</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
